/**
 * @todo refactor
 */
export function getFiltersFromTableData(materialsTableData: MaterialData[]) {
  return materialsTableData.reduce((acc, val) => {
    if (val.tags) {
      val.tags.forEach(filter => {
        if (filter && !acc.includes(filter)) {
          acc.push(filter);
        }
      });
    }
    return acc;
  }, [] as string[]);
}

/**
 * @todo refactor
 */
export function filterTableData(
  materialsTableData: MaterialData[],
  selectedFilters: string[]
) {
  return materialsTableData.filter(r =>
    selectedFilters.reduce((acc, val) => {
      if (!r.tags.includes(val)) return false;
      return acc;
    }, true)
  );
}
